var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeclineDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Action button",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.10391,
    y: 1.05313,
    width: 22.8,
    height: 22.8,
    rx: 2.4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.2676 18.2168L12.5039 12.4531M12.5039 12.4531L6.74023 6.68945M12.5039 12.4531L18.2676 6.68945M12.5039 12.4531L6.74023 18.2168",
    stroke: "#D86674",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.10391,
    y: 1.05313,
    width: 22.8,
    height: 22.8,
    rx: 2.4,
    stroke: "#D86674",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineDisabled);
export default __webpack_public_path__ + "static/media/decline_disabled.8234b721e1fc0802fff3f5f832bd4a4e.svg";
export { ForwardRef as ReactComponent };